var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerIoinline = function SvgCustomerIoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    y: 0.564,
    fill: "#0A353B",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4FFCD",
    d: "M5.033 9.599 4 10.637v2.07h2.074l1.04-1.039 1.033-1.03L6.074 8.56zM7.115 5.445 6.074 4.412H4v2.074l1.033 1.04 1.04 1.034 2.074-2.074zM10.225 4.412H8.147v2.072l2.078 2.072-2.078 2.08v2.071h2.078l2.07-2.072V6.484z"
  })));
};
export default SvgCustomerIoinline;